import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";

export function AccessDeniedPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="rounded-full bg-red-100 p-4 mb-6">
        <svg className="h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        {t("errors:accessDenied.title")}
      </h1>
      <p className="text-gray-500 max-w-md mb-8">
        {t("errors:accessDenied.message")}
      </p>
      <Link to="/">
        <Button>{t("errors:accessDenied.backToDashboard")}</Button>
      </Link>
    </div>
  );
}
